import { Component, Input, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { CouponService } from "../../../service/service.index";
import { Coupon } from "../../../models/coupon/coupon";
@Component({
  selector: "app-coupon",
  templateUrl: "./coupon.component.html",
  styleUrls: ["./coupon.component.scss"],
})
export class CouponComponent implements OnInit {
  working: boolean;
  dateInitial = new Date();
  columnsCoupon = ["RegisterDate", "Mount", "Code", "Active"];
  dataSourceCoupon = new MatTableDataSource<any>();
  coupons: Coupon[] = [];
  bandera: any[] = [];
  // Obtenemos los estudiantes
  @Input("band") set active(value) {
    this.dataSourceCoupon.data = value;
  }

  constructor() {}

  ngOnInit() {}
}
